import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import SVG from "components/base/SVG";
import css from "./style.scss";
import CloseIcon from "assets/images/closeicon.svg";
import { use } from "react";

const MultiSelect = ({
  lists = [],
  placeholder = "Select",
  selectedValues = [],
  onSelect,
}) => {
  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState(lists);
  const [isActionDropdownOpen, setIsActionDropdownOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [selectedItems, setSelectedItems] = useState([]);
  const [visibleCount, setVisibleCount] = useState(0);
  const moreRef = useRef(null);
  const caretRef = useRef(null);

  console.log('selectedValues', selectedValues);
  console.log('query', query);
  console.log('selectedItems', selectedItems);


  const wrapperRef = useRef(null);
  const containerRef = useRef(null);
  const measureRef = useRef(null);

  useEffect(() => {
    const sorted = [...lists].sort((a, b) =>
      a.name.localeCompare(b.name, "en", { sensitivity: "base" })
    );
    setFiltered(sorted);
  }, [lists]);

  useEffect(() => {
    if (!selectedValues || !lists.length) return;
    const selected = lists.filter((item) => selectedValues.includes(item.id));
    setSelectedItems(selected);
  }, [selectedValues.join(), lists]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsActionDropdownOpen(false);
        setActiveIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isActionDropdownOpen) {
      setVisibleCount(selectedItems.length);
      return;
    }

    if (!containerRef.current || !measureRef.current) return;

    const containerWidth = containerRef.current.clientWidth;
    const caretWidth = caretRef.current?.offsetWidth || 0;
    const moreWidth = moreRef.current?.offsetWidth || 0;

    let usedWidth = 0;
    let count = 0;

    const chips = Array.from(measureRef.current.children);

    for (let i = 0; i < chips.length; i++) {
      const chipWidth = chips[i].offsetWidth;

      // Reserve space for "+X more" + caret
      const remaining =
        containerWidth - usedWidth - caretWidth - moreWidth;

      if (chipWidth <= remaining) {
        usedWidth += chipWidth;
        count++;
      } else {
        break;
      }
    }

    setVisibleCount(count);
  }, [selectedItems, isActionDropdownOpen]);


  const visibleChips = selectedItems.slice(0, visibleCount);
  const hiddenCount = selectedItems.length - visibleCount;

  const handleInput = (value) => {
    setQuery(value);
    setIsActionDropdownOpen(true);
    setFiltered(
      lists.filter((l) =>
        l.name.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleSelect = (item) => {
    const exists = selectedValues.includes(item.id);
    const updated = exists
      ? selectedValues.filter(id => id !== item.id)
      : [...selectedValues, item.id];

    onSelect(updated); // parent updates state
  };

  const handleRemove = (id) => {
    onSelect(selectedValues.filter(i => i !== id));
  };

  return (
    <div className={css.wrapper} ref={wrapperRef}>
      <div
        className={classNames(css.inputBox, {
          [css.open]: isActionDropdownOpen,
        })}
        onClick={() => setIsActionDropdownOpen(true)}
      >
        <div className={css.chipsContainer} ref={containerRef}>
          {visibleChips.map((item) => (
            <div key={item.id} className={css.chip}>
              {item.name}
              <div
                className={css.chipClose}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemove(item.id);
                }}
              >
                {/* <SVG icon="iconClose" className={css.chipCloseicon} /> */}
                <img src={CloseIcon} alt="close icon" className={css.chipCloseicon} />
              </div>
            </div>
          ))}

          {!isActionDropdownOpen && hiddenCount > 0 && (
            <span className={css.moreBadge}>+{hiddenCount} more</span>
          )}

          <input
            value={query}
            className={classNames(css.input, {
              [css.inputHidden]:
                !isActionDropdownOpen && selectedItems.length > 0,
            })}
            placeholder={selectedItems.length ? "" : placeholder}
            onChange={(e) => handleInput(e.target.value)}
            onFocus={() => setIsActionDropdownOpen(true)}
          />
        </div>

        <SVG
          icon="iconCaretDown"
          className={css.dropdownCaretIcon}
          ref={caretRef}
        />

      </div>

      {isActionDropdownOpen && (
        <ul className={css.dropdown}>
          {filtered.length > 0 ? (
            filtered.map((item, i) => (
              <li
                key={item.id}
                className={classNames(css.item, {
                  [css.selected]: selectedItems.some((s) => s.id === item.id),
                  [css.active]: i === activeIndex,
                })}
                onClick={() => handleSelect(item)}
              >
                {item.name}
              </li>
            ))
          ) : (
            <li className={css.noMatch}>No Matches</li>
          )}
        </ul>
      )}
      <div className={css.measure}>
        <span ref={moreRef} className={css.moreBadge}>
          +{hiddenCount || 1} more
        </span>
      </div>

      <div className={css.measure} ref={measureRef}>
        {selectedItems.map((item) => (
          <div key={item.id} className={css.chip}>
            {item.name}
            <img src={CloseIcon} alt="close icon" className={css.chipCloseicon} />
          </div>
        ))}
      </div>

    </div>
  );
};

export default MultiSelect;